import axios from "axios";

export const UNREGISTERED_STUDENT_URL = "/UnregisteredStudent";

/** Mevcut Okulun Belli Bir Okul Dışı Öğrenci Listesini Elde Eder */
export function getUnregisteredStudents(queryParams) {
  return axios.post(`${UNREGISTERED_STUDENT_URL}/GetUnregisteredStudents`, queryParams);
}

/** Mevcut Okulun Belli Bir Okul Dışı Öğrenci Listesini Sayfalama Olmadan Elde Eder */
export function getAllUnregisteredStudents(queryParams) {
  return axios.post(`${UNREGISTERED_STUDENT_URL}/GetAllUnregisteredStudents`, queryParams);
}

/** Yeni Bir Okul Dışı Öğrenci Elde Eder */
export function getNewUnregisteredStudent() {
  return axios.get(UNREGISTERED_STUDENT_URL);
}

/** Belli Bir Okul Dışı Öğrenciyi Elde Eder */
export function getUnregisteredStudent(id) {
  return axios.get(`${UNREGISTERED_STUDENT_URL}/${id}`);
}

/** Belli Bir Okul Dışı Öğrenciyi Kaydeder */
export function saveUnregisteredStudent(student) {
  return axios.post(UNREGISTERED_STUDENT_URL, student);
}

/** Belli Bir Okul Dışı Öğrenci Listesini Siler */
export function deleteUnregisteredStudents(ids) {
  return axios.post(`${UNREGISTERED_STUDENT_URL}/Delete`, { ids });
}